<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>用车费用</h4>
    </div>
    <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form
        :inline="true"
        :model="searchFrom"
        class="demo-form-inline"
        label-width="90px"
        size="mini"
      >
        <div class="inpBox">
          <el-form-item label="用车日期:" prop="deliveryDate">
            <el-date-picker
              v-model="searchFrom.applyStartTime"
              size="mini"
              style="width: 190px"
              placeholder="选择日期"
              type="date"
              value-format="yyyy-MM-dd"
            ></el-date-picker>&nbsp;-&nbsp;&nbsp;
            <el-date-picker
              v-model="searchFrom.applyEndTime"
              size="mini"
              style="width: 190px"
              placeholder="选择日期"
              type="date"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="用车部门:" prop="departmentCode">
            <el-select v-model="searchFrom.departmentCode" placeholder="请选择" @change="carUnitChange(searchFrom.departmentCode)">
              <el-option
                v-for="item in carUnitOptions"
                :key="item.orgCode"
                :label="item.orgName"
                :value="item.orgCode">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用车单位:" prop="subsidiaryDepartmentCode">
            <el-select v-model="searchFrom.subsidiaryDepartmentCode" @change="carAreaChange()" placeholder="请选择">
              <el-option
                v-for="item in carAreaOptions"
                :key="item.orgCode"
                :label="item.orgName"
                :value="item.orgCode">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工作类型:" prop="jobType">
            <el-select v-model="searchFrom.workType" placeholder="请选择">
             <el-option
                v-for="(item, index) in jobTypeOptions"
                :key="index"
                :label="item.showName"
                :value="item.itemNo"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车型:" prop="carType">
            <el-select v-model="searchFrom.vhcTypeId" filterable placeholder="请选择">
              <el-option
                v-for="(item, index) in carTypeOptions"
                :key="index"
                :label="item.typeName"
                :value="item.typeId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="searchBtnBox">
          <el-form-item>
            <el-button type="primary" @click="searchClick" btnCode="00MP005B001" v-if="btnFlg[0]">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="chongZhiClick" btnCode="00MP005B002" v-if="btnFlg[1]">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="tongJi">
      <div class="tongJi_item">
        费用合计：<span style="color:red;">{{moneyHeJi}}</span>&nbsp;&nbsp;元
      </div>
    </div>
    <!--  表格 -->
    <div class="table" :style="{ height: h }" v-loading='tabLoading'>
      <el-table
        :data="tableList"
        border
        bordersize="mini"
        height="100%"
        style="width: 100%; margin-top: 10px"
        center
        :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
        :header-row-style="{ height: '45px' }"
        :row-style="{ height: '35px' }"
        highlight-current-row
      >
        <!-- <el-table-column type="selection" width="55" align="center" ></el-table-column> -->
        <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="taskNo" label="作业单号" align="center" width="250"></el-table-column>
        <el-table-column prop="departmentName" label="用车部门" align="center"  :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="subsidiaryDepartmentName" label="用车单位" align="center" width="120"></el-table-column>
        <el-table-column prop="vehicleNo" label="车号" align="center" width="100" ></el-table-column>
        <el-table-column prop="fleetName" label="车队" align="center" width="180" ></el-table-column>
        <el-table-column prop="driverName" label="司机" align="center" width="100" ></el-table-column>
        <el-table-column prop="vhcTypeName" label="车型" align="center" width="100" ></el-table-column>
        <el-table-column prop="tonnageModel" label="吨位/机型" align="center" width="100"></el-table-column>
        <el-table-column prop="price" label="单价" align="center" width="120" ></el-table-column>
        <el-table-column prop="actualWorkDuration" label="工作量" align="center" width="150" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="workPrice" label="费用" align="center" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="workType" label="工作类型" align="center" width="150" ></el-table-column>
        <el-table-column prop="workContent" label="工作内容" align="center" width="180" ></el-table-column>
        <el-table-column prop="applyTimeShow" label="计划工作时间" align="center" width="320"></el-table-column>
        <el-table-column prop="actulTimeShow" label="实际工作时间" align="center" width="320"></el-table-column>
        <el-table-column prop="applyNo" label="申请单号" align="center" width="200"></el-table-column>
        <el-table-column prop="applyUser" label="用车人" align="center" width="100" ></el-table-column>
        <el-table-column prop="userMobile" label="联系电话" align="center" width="130"  :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="vhcapplyAddress" label="工作地点" align="center" width="180" ></el-table-column>
        <el-table-column prop="createTime" label="派车时间" align="center" width="180"  :formatter="formatterRowEmpty"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[10, 25, 50, 100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {
  totalCost, // 总费用
  fleetTypeMenu, // 车型下拉框
  applyCost, // 查询列表
  getAllOrgUserTreeData, // 用车单位下拉框
  getDictionaryList
} from '@/api/zhbPlantVehicles.js'
import { getBtn } from '@/utils/getButton'
import { emptyFn, formatterRowEmpty } from '@/utils/util'
export default {
  data () {
    return {
      emptyFn: emptyFn,
      formatterRowEmpty: formatterRowEmpty,
      // 按钮
      btnFlg: [],
      btnIdArr: [
        '00MP005B001',
        '00MP005B002'
      ],
      title: '',
      h: '500px',
      total: 0,
      searchFrom: {
        pageNo: 1,
        pageSize: 10,
        applyStartTime: '',
        applyEndTime: ''
      },
      preSearchFrom: {},
      // 工作类型
      jobTypeOptions: [],
      // 车型
      carTypeOptions: [],
      carUnitOptions: [],
      carAreaOptions: [],
      tableList: [],
      tabLoading: false,
      moneyHeJi: 0,
      test: {}
    }
  },
  created () {
    this.getToDay()
    this.btnFlg = getBtn(this.btnIdArr, '/vehicleController/carCost')
    this.getDictionaryList()
    this.getVheTypeList()
    this.getAllOrgUserTreeData()
    this.getSeatchData(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 150 + 'px'
  },
  methods: {
    // 时间格式化
    timeStamp (value) { // 具体到时分秒
      var date = new Date(value) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var year = date.getFullYear()
      var month = ('0' + (date.getMonth() + 1)).slice(-2)
      var sdate = ('0' + date.getDate()).slice(-2)
      var hour = ('0' + date.getHours()).slice(-2)
      var minute = ('0' + date.getMinutes()).slice(-2)
      var second = ('0' + date.getSeconds()).slice(-2)
      // 拼接
      var result = year + '-' + month + '-' + sdate + ' ' + hour + ':' + minute + ':' + second
      // 返回
      return result
    },
    // 年月日
    timeStamp2 (value) {
      if (!value) return ''
      var now = new Date(value)
      // console.log("time:" + JSON.stringify(now));
      var year = now.getFullYear()
      var month = now.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      var date = now.getDate()
      if (date < 10) {
        date = '0' + date
      }
      return year + '-' + month + '-' + date
    },
    // 计划开始时间-当前日期早8点
    getToDay () {
      // 前一月
      var now = new Date()
      var month1 = now.setMonth(now.getMonth() - 1)
      this.searchFrom.applyStartTime = this.timeStamp2(month1)
      this.searchFrom.applyEndTime = this.timeStamp2(new Date())
    },
    // 查询接口
    getSeatchData (param) {
      this.tabLoading = true
      applyCost(param).then((res) => {
        this.tabLoading = false
        this.total = res.total
        this.tableList = res.list
      }).catch((err) => {
        this.tabLoading = false
        this.$message.error(err.message)
      })
      let search = this.searchFormIsSame(param)
      if (search) {
        totalCost(param).then(res => {
          this.tabLoading = false
          this.moneyHeJi = res
        }).catch((err) => {
          this.tabLoading = false
          this.$message.error('查询费用合计失败')
        })
      }
      this.preSearchFrom.applyStartTime = param.applyStartTime
      this.preSearchFrom.applyEndTime = param.applyEndTime
      this.preSearchFrom.workType = param.workType
      this.preSearchFrom.vhcTypeId = param.vhcTypeId
      this.preSearchFrom.departmentCode = param.departmentCode
      this.preSearchFrom.subsidiaryDepartmentCode = param.subsidiaryDepartmentCode
    },
    valueIsNull (value) {
      return value == null || value == undefined || value == ''
    },
    searchFormIsSame (param) {
      let search = false
      search = !(this.valueIsNull(param.applyStartTime) == this.valueIsNull(this.preSearchFrom.applyStartTime))
      if (search) {
        return search
      }
      search = !(param.applyStartTime == this.preSearchFrom.applyStartTime)
      if (search) {
        return search
      }
      search = !(this.valueIsNull(param.applyEndTime) == this.valueIsNull(this.preSearchFrom.applyEndTime))
      if (search) {
        return search
      }
      search = !(param.applyEndTime == this.preSearchFrom.applyEndTime)
      if (search) {
        return search
      }
      search = !(this.valueIsNull(param.workType) == this.valueIsNull(this.preSearchFrom.workType))
      if (search) {
        return search
      }
      search = !(param.workType == this.preSearchFrom.workType)
      if (search) {
        return search
      }
      search = !(this.valueIsNull(param.vhcTypeId) == this.valueIsNull(this.preSearchFrom.vhcTypeId))
      if (search) {
        return search
      }
      search = !(param.vhcTypeId == this.preSearchFrom.vhcTypeId)
      if (search) {
        return search
      }
      search = !(this.valueIsNull(param.departmentCode) == this.valueIsNull(this.preSearchFrom.departmentCode))
      if (search) {
        return search
      }
      search = !(param.departmentCode == this.preSearchFrom.departmentCode)
      if (search) {
        return search
      }
      search = !(this.valueIsNull(param.subsidiaryDepartmentCode) == this.valueIsNull(this.preSearchFrom.subsidiaryDepartmentCode))
      if (search) {
        return search
      }
      search = !(param.subsidiaryDepartmentCode == this.preSearchFrom.subsidiaryDepartmentCode)
      if (search) {
        return search
      }
    },
    // 点击查询按钮
    searchClick () {
      this.getSeatchData(this.searchFrom)
    },
    // 点击重置
    chongZhiClick () {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 10
      }
      this.getSeatchData(this.searchFrom)
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getSeatchData(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getSeatchData(this.searchFrom)
    },
    // 获取工作类型下拉框
    getDictionaryList () {
      getDictionaryList({
        groupNo: 'work_type'
      })
        .then((res) => {
          this.jobTypeOptions = res
        })
        .catch((err) => {
          this.$message.error(err.message)
        })
    },
    // 获取车型下拉框
    getVheTypeList () {
      fleetTypeMenu()
        .then((res) => {
          this.carTypeOptions = res
        })
        .catch((err) => {
          this.$message.error(err.message)
        })
    },
    // 获取用车单位下拉框
    getAllOrgUserTreeData () {
      getAllOrgUserTreeData().then((res) => {
        this.test = JSON.parse(res)
        this.carUnitOptions = this.test.children
        console.log(this.test, 'this.test')
      }).catch((err) => {
        this.$message.error(err.message)
      })
    },
    // 用车单位值改变时
    carUnitChange (item) {
      this.searchFrom.subsidiaryDepartmentCode = ''
      if (item != null && item != undefined && item != '') {
        this.carAreaOptions = []
        for (let index = 0; index < this.carUnitOptions.length; index++) {
          let element = this.carUnitOptions[index]
          console.log(element, 'element')
          if (element.orgCode == item) {
            this.carAreaOptions = element.children
            return
          }
        }
      }
    },
    carAreaChange () {
      this.$forceUpdate() // 强制刷新
    }
  }
}
</script>
<style scoped lang='less'>
.el-table {
  overflow: visible !important;
}
.searchBox {
  margin-left: 25px;
}
.inpBox {
  margin: 10px 0 0 -30px;
}
.searchBtnBox {
  margin-top: 10px;
  margin-left: -20px;
}
.el-table__header tr,
.el-table__header th {
  padding: 0;
  height: 40px;
}
.tongJi {
  display: flex;
  margin-left: 10px;
  margin-bottom: 20px;
}
.tongJi_item {
  margin-right: 20px;
}
.tongJi_item span {
  color: red;
}
</style>
